import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import apiClient from '@/lib/apiClient';

const buildSubmitPayload = (state) => ({
  respondent: state.profile,
  awasi_core: state.awasi,
  extended_module: state.extended,
  workflows: state.workflows
    .filter(wf => wf.name.trim() !== '')
    .map(({ slotId, ...rest }) => rest),
  consent_given: state.consent,
});

const submitAssessment = (payload, navigate, setLoading) => {
  setLoading(true);
  return apiClient.post('/assessments', payload)
    .then(r => {
      toast.success('Assessment submitted successfully!');
      navigate(`/results/${r.data.id}`);
    })
    .catch(() => toast.error('Failed to submit assessment. Please try again.'))
    .finally(() => setLoading(false));
};

/**
 * Encapsulates the network-side concern of the assessment form: turning the
 * collected state into a payload and POSTing it to the backend.
 */
export function useAssessmentSubmit() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const submit = (state) =>
    submitAssessment(buildSubmitPayload(state), navigate, setLoading);

  return { loading, submit };
}
